import { Controller } from "react-hook-form";
import { useFormContext } from "react-hook-form";

import { Button } from "ui/button";
import { DialogActions, DialogBackButton } from "ui/dialog";
import { TextArea } from "ui/text-area";

import { useParentTouchpointContext } from "components/modals/create-parent-touchpoint-modal/context/parent-touchpoint-context";
import { useCreateParentTouchpointModal } from "components/modals/create-parent-touchpoint-modal/hooks/use-create-parent-touchpoint-modal";

import { getClientPaths } from "utilities/app-routes";

const ParentTouchpointPrompt = () => {
  const { control } = useFormContext();
  const { selectedCampaign } = useParentTouchpointContext();

  const clientId = selectedCampaign.clientId || "";
  const { clientProfilePath } = getClientPaths({ clientId });

  return (
    <div className="flex flex-col gap-4 w-full">
      <p>
        Apollo generates the Parent Email based on client-specific rules. To tailor tone, content,
        or structure, you can edit the{" "}
        <a
          href={clientProfilePath}
          target="_blank"
          className="text-aqua-600 font-semibold underline">
          parent email rules
        </a>{" "}
        for this client.
      </p>
      <p>Add any additional instructions if needed for this specific Parent Email.</p>
      <Controller
        key="emailPrompt"
        name="emailPrompt"
        control={control}
        render={({ field }) => (
          <TextArea
            label="Parent email additional instructions"
            {...field}
            rows={4}
            value={field.value || ""}
            resize="vertical"
          />
        )}
      />
    </div>
  );
};

export const ParentTouchpointPromptActions = () => {
  const { handleGenerateEmail, handleStepChange } = useCreateParentTouchpointModal();

  return (
    <DialogActions
      type="steps"
      back={<DialogBackButton onClick={() => handleStepChange(1)}>Back to name</DialogBackButton>}
      primary={
        <Button size="large" onClick={handleGenerateEmail}>
          Generate email
        </Button>
      }
    />
  );
};

export default ParentTouchpointPrompt;
